import { z } from 'zod'

const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/

// Supports Date JS dates and ISO strings.
const hybridDateSchema = z.union([
  z.date(),
  z.string()
    .refine(str => isoDateRegex.test(str), {
      message: 'Invalid ISO date format',
    })
    .transform(str => new Date(str)),
])

export const businessExpenseSchema = z.object({
  id: z.coerce.number().optional(),
  shift_id: z.coerce.number().positive().optional().nullable(),
  amount: z.coerce.number().min(0, 'Amount must be a non-negative number'),
  notes: z.string().optional().nullable(),
  created_at: hybridDateSchema.optional(),
  updated_at: hybridDateSchema.optional(),
  expense_date: hybridDateSchema.optional(),
  business_id: z.string().uuid(),

  // Use new ID-based field (preferred)
  expense_id: z.coerce.number().positive('Please select a valid expense type'),

  // Money source the expense was taken from - references fund_sources.id.
  // Required moving forward; legacy rows in the DB may be null.
  fund_source_id: z.coerce.number().positive('Please select a valid fund source'),
})

export const businessExpenseResponseSchema = z.object({
  success: z.boolean(),
  total: z.number(),
  data: z.array(businessExpenseSchema),
})

export type BusinessExpense = z.infer<typeof businessExpenseSchema>
export type BusinessExpenseResponse = z.infer<typeof businessExpenseResponseSchema>
